import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LockUserModalComponent } from '../lock-user-modal/lock-user-modal.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'lock-user-warning-modal',
	template: require('./lock-user-warning-modal.component.html'),
})
export class LockUserWarningModalComponent {
	data = {
		icon: 'lock-account',
		title: 'Κλείδωμα λογαριασμού',
		text: 'Αν έχετε πέσει θύμα απάτης και τα στοιχεία του λογαριασμού σας έχουν διαρρεύσει, κλειδώστε τον λογαριασμό σας άμεσα για να εξασφαλίσετε:',
		bullets: [
			'Διακοπή των ενεργών συνδέσεων σας στο Digital Banking',
			'Αποσύνδεση του λογαριασμού σας από όλες τις συσκευές',
			'Διαγραφή των στοιχείων σας από όλους του broswers.',
		],
		approveButton: 'Συνέχεια',
	};

	phone = '+30 210 77 27 440';
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal, private _modalService: NgbModal) {}

	closeModal(): void {
		this.activeModal.close();
	}

	openModal(): void {
		this.activeModal.close();
		this._modalService.open(LockUserModalComponent, {
			windowClass: 'modal-full',
		});
	}
}
